import React from "react";
import "./buttonSelectLogsType.css";
import { LOG_TYPES } from "../../../features/log/constants/logTypeConstants.js";
import { VscWarning } from "react-icons/vsc";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { VscError } from "react-icons/vsc";
import { AiOutlineSetting } from "react-icons/ai";

const ButtonSelectLogsType = ({ options, field, form: { setFieldValue } }) => {
  const value = getValue(options, field);
  const handleChange = (option) => {
    if (!option) {
      return setFieldValue(field.name, null);
    }
    const newValue = Array.isArray(option.value)
      ? option.map((item) => item.value)
      : option.value;

    return setFieldValue(field.name, newValue);
  };
  const getClassName = (option) => {
    const base =
      "d-flex justify-content-around selectable-button-logs align-items-center ";
    if (!value.length) {
      return base;
    }

    if (option.value === value[0].value) {
      return base + "active-selectable-button";
    }
    return base;
  };

  function RenderIcon({ optionValue }) {
    const isSelectedOpacity = () =>
      value.length && value[0].value === optionValue ? 1 : 0.8;

    switch (optionValue) {
      case LOG_TYPES.INFO:
        return (
          <IoIosInformationCircleOutline
            style={{ opacity: isSelectedOpacity() }}
            color="#0088E4"
            size={25}
          />
        );
      case LOG_TYPES.WARN:
        return (
          <VscWarning
            style={{ opacity: isSelectedOpacity() }}
            color="#FCB925"
            size={25}
          />
        );
      case LOG_TYPES.ERROR:
        return (
          <VscError
            style={{ opacity: isSelectedOpacity() }}
            color="#FF0000"
            size={25}
          />
        );
      case LOG_TYPES.REGULARPROCESSINFO:
        return (
          <AiOutlineSetting
            style={{ opacity: 1 }}
            color="#7A8790"
            size={25}
          />
        );

      default:
        return <span>...</span>;
    }
  }
  return (
    <div className="button-select-logs-box">
      {options.map((option, i) => {
        return (
          <div
            key={`${i}-${option.value}`}
            className={getClassName(option)}
            color="primary"
            onClick={() => handleChange(option)}
          >
            <RenderIcon optionValue={option.value} />
            {option.label}
          </div>
        );
      })}
    </div>
  );
};

function getValue(options, field) {
  if (!options) {
    return "";
  }

  return options.filter((option) =>
    Array.isArray(field.value)
      ? field.value.indexOf(option.value) >= 0
      : field.value === option.value
  );
}

export default ButtonSelectLogsType;



// WEBPACK FOOTER //
// ./src/components/formik/logs-list/ButtonSelectLogsType.jsx